import { IconArrowLeft } from "@tabler/icons-react";
export const NotFound = () => {
  return (
    <div className="page page-center border-top-wide border-primary">
      <div className="container-tight py-4">
        <div className="empty">
          <div className="empty-header">404</div>
          <p className="empty-title">Oops… Not Found</p>
          <p className="empty-subtitle text-muted">
            We are sorry but the page you are looking for was not found
          </p>
          <div className="empty-action">
            <a href="/" className="btn btn-primary">
              <IconArrowLeft className="icon" />
              Take me home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
